<template>
  <div
    class="average-line"
    :style="`
      bottom: calc(${max_value !== 0? `${(value / max_value)} * (100% - 25px)`:'0px'});
      ${width?`width: ${width};`:''}
    `"
  >
  <div class="average-line-value" v-if="value !== 0">{{value}}</div>
  <div class="average-line-marker">
    <slot/>
  </div>
  </div>
</template>
<script>
  export default {
    props: ['value', 'max_value', 'width'],
  }
</script>
<style>
  .average-line {
    display: flex;
    position: absolute;
    height: 1px;
    width: 35px;
    overflow: visible;
    color: white;
    border-bottom: dashed white 1px;
    transition: bottom 0.4s ease-in-out, width ease-in-out 0.2s;
    justify-content: center;
  }
  .average-line-marker {
    position: absolute;
    left: 110%;
    transform: translateY(-50%);
  }
  .average-line-value {
    position: absolute;
  }
</style>
